import { combineReducers } from 'redux'
import Test from 'redux/store/Test/reducer'

const rootReducer = combineReducers({
  Test
})

export default rootReducer